// File: src/components/Footer.js
import React from "react";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Main black section */}
      <div className="footer-content">
        <h1 className="footer-heading">
          Set a New Path
          <br />
          to Sustainable Growth
        </h1>

        {/* Contact & Social row */}
        <div className="footer-contact-row">
          {/* Left side: Chat With Us */}
          <div className="footer-contact-left">
            <p className="footer-subtitle">Chat With Us</p>
            <p className="footer-info">XXX.XXX.XXX</p>
            <p className="footer-info">hello@nexavista.co.uk</p>
          </div>

          {/* Right side: Follow Us + LinkedIn */}
          <div className="footer-contact-right">
            <p className="footer-subtitle">Follow Us</p>
            <a
              href="https://www.linkedin.com/company/nexavista-strategies/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/static/images/linkedin-icon.png"
                alt="LinkedIn"
                className="footer-social-icon"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom white strip */}
      <div className="footer-content-2">
        <p className="footer-powered-by"></p>
      </div>
    </footer>
  );
};

export default Footer;
